/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { FaCopy, FaKey, FaCog, FaFile, FaCodeBranch, FaRegEdit, FaRegUser } from 'react-icons/fa';
import { TbRefresh } from 'react-icons/tb';
import { OverlayTrigger, Tooltip, Alert, Button } from "react-bootstrap";
import { Switch, FormControlLabel, TextField, InputLabel } from '@material-ui/core';
import { Link } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { NODE_API_URL, BASE_URL } from "../../../../env_config";
import { useHistory } from "react-router-dom";
import UpgradeSubscriptionPage from "../../apiv3/UpgradeSubscriptionPage";
import moment from "moment-timezone";
import { GetCookies } from "../../../_helpers/Cookies";
import { SwalWarn } from "../../Popup";
import { TaxPopUp } from "../../Popup/TaxPopUp";
import SelectFieldCurrency from "../../DiamondFeedNew/ApiSetup/FormFields/SelectFieldCurrency";
import { BsArrowLeftShort } from "react-icons/bs";

export const ApiCurrencyAndTax = (props) => {
    // console.log(props.userinfo.id,"ApiSettingsApiSettings")
    const [value, setValue] = React.useState('');
    const [checked, setChecked] = React.useState();
    const [userdata, setUserData] = useState()
    const [credentailgen, setCredentialGen] = useState(false)
    const [showsubscription, setShowSubscription] = useState(false)
    const [inr, setInr] = useState(0)
    const [usd, setUsd] = useState(0)
    const [cad, setCad] = useState(0)
    const [aud, setAud] = useState(0)
    const [hkd, setHkd] = useState(0)
    const [cny, setCny] = useState(0)
    const [eur, setEur] = useState(0)
    const [gbp, setGbp] = useState(0)
    const [nzd, setNzd] = useState(0)
    const [jpy, setJpy] = useState(0)
    const [chf, setChf] = useState(0)
    const [sgd, setSgd] = useState(0)
    const [thb, setThb] = useState(0)
    const [myr, setMyr] = useState(0)
    const [bnd, setBnd] = useState(0)
    const [dkk, setDkk] = useState(0)
    const [sek, setSek] = useState(0)
    const [currencyvalue, setCurrencyValue] = useState("")

    const [taxname, setTaxName] = useState("")
    const [taxvalue, setTaxValue] = useState(0)
    const [edittax, setEditTax] = useState(false)
    const [updatestate, setUpdateState] = useState(false)
    useEffect(() => {
        if (props.userinfo) {
            axios({
                method: "get",
                url: `${NODE_API_URL}/INTL/fetch-iframeorapi`,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
                }
            }).then(supreq => {
                if (supreq && supreq.data && supreq.data.data) {
                    // setFeedLoader(false)
                    setUserData(supreq.data.data)
                    GetCookies("conversionrates").then(response => {
                        // console.log(response,"Conversionresponse")
                        if (response && response[0]) {
                            const currencies = JSON.parse(response)
                            // console.log(currencies,"currencies")
                            setInr(Math.round(currencies[0].cur_inr * 100) / 100)
                            setUsd(Math.round(currencies[0].cur_usd * 100) / 100)
                            setCad(Math.round(currencies[0].cur_cad * 100) / 100)
                            setAud(Math.round(currencies[0].cur_aud * 100) / 100)
                            setHkd(Math.round(currencies[0].cur_hkd * 100) / 100)
                            setCny(Math.round(currencies[0].cur_cny * 100) / 100)
                            setEur(Math.round(currencies[0].cur_eur * 100) / 100)
                            setGbp(Math.round(currencies[0].cur_gbp * 100) / 100)
                            setNzd(Math.round(currencies[0].cur_nzd * 100) / 100)
                            setJpy(Math.round(currencies[0].cur_jpy * 100) / 100)
                            setChf(Math.round(currencies[0].cur_chf * 100) / 100)
                            setSgd(Math.round(currencies[0].cur_sgd * 100) / 100)
                            setThb(Math.round(currencies[0].cur_thb * 100) / 100)
                            setMyr(Math.round(currencies[0].cur_myr * 100) / 100)
                            setBnd(Math.round(currencies[0].cur_bnd * 100) / 100)
                            setDkk(Math.round(currencies[0].cur_dkk * 100) / 100)
                            setSek(Math.round(currencies[0].cur_sek * 100) / 100)
                        }
                    })
                    setCurrencyValue(supreq.data.data.api_currency)
                    setTaxName(supreq.data.data.api_taxname)
                    setTaxValue(supreq.data.data.api_taxvalue)
                }
            }).
                catch(error => {
                    if (error?.response?.data?.message === "UnAuthorized!") {
                        var cookies = document.cookie.split(";");
                        for (var i = 0; i < cookies.length; i++) {
                            if (cookies[i] && !cookies[i].includes("view")) {
                                var equals = cookies[i].indexOf("=");
                                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                            }
                        }

                        window.location.replace(`${BASE_URL}/logout`);
                    }
                })
        }
    }, [value, updatestate])
    const muti_currency_data = [
        {
            value: 'INR',
            label: `INR  - ${inr.toFixed(2)}`
        },
        {
            value: 'USD',
            label: `USD $ - ${usd.toFixed(2)}`
        },
        {
            value: 'CAD',
            label: `CAD $ - ${cad.toFixed(2)}`
        },
        {
            value: 'AUD',
            label: `AUD $ - ${aud.toFixed(2)}`
        },
        {
            value: 'HKD',
            label: `HKD $ - ${hkd.toFixed(2)}`
        },
        {
            value: 'CNY',
            label: `CNY ¥ - ${cny.toFixed(2)}`
        },
        {
            value: 'EUR',
            label: `EUR € - ${eur.toFixed(2)}`
        },
        {
            value: 'GBP',
            label: `GBP £ - ${gbp.toFixed(2)}`
        },
        {
            value: 'NZD',
            label: `NZD $ - ${nzd.toFixed(2)}`
        },
        {
            value: 'JPY',
            label: `JPY ¥ - ${jpy.toFixed(2)}`
        },
        {
            value: 'CHF',
            label: `CHF ₣ - ${chf.toFixed(2)}`
        },
        {
            value: 'SGD',
            label: `SGD $ - ${sgd.toFixed(2)}`
        },
        {
            value: 'THB',
            label: `THB ฿ - ${thb.toFixed(2)}`
        },
        {
            value: 'MYR',
            label: `MYR RM - ${myr.toFixed(2)}`
        },
        {
            value: 'BND',
            label: `BND $ - ${bnd.toFixed(2)}`
        },
        {
            value: 'DKK',
            label: `DKK kr. - ${dkk.toFixed(2)}`
        },
        {
            value: 'SEK',
            label: `SEK kr - ${sek.toFixed(2)}`
        }
    ];

    const CancelTax = () => {
        setEditTax(false)
        setUpdateState(!updatestate)
    }
    const SaveTax = () => {
        setEditTax(false)
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/update-Api-CurrencyAndTax`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
            },
            data: {
                "columnname": "tax",
                "api_taxname": taxname,
                "api_taxvalue": taxvalue
            },
        }).then(supreq => {
            if (supreq && supreq.data) {
                if (supreq.data === "Data Updated Successfully") {
                    setUpdateState(!updatestate)
                }
            }
        }).
            catch(error => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            })
    }
    const [swalWarnOpen, setSwalWarnOpen] = useState(false)
    const [popupcurrency, setPopupCurrency] = useState("")
    const OpenPopup = (value) => {
        setSwalWarnOpen(true)
        setPopupCurrency(value)
    }
    const UpdateCurrency = (value) => {
        console.log("UpdateCurrency")
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/update-Api-CurrencyAndTax`,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
            },
            data: {
                "columnname": "currency",
                "api_currency": value
            },
        }).then(supreq => {
            if (supreq && supreq.data) {
                if (supreq.data === "Data Updated Successfully") {
                    setUpdateState(!updatestate)
                    setSwalWarnOpen(false)
                }
            }
        }).
            catch(error => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            })
    }
    function handleChange(event) {
        // console.log(event.target.checked,"CHECKEDDDDD")
        axios({
            method: "POST",
            url: NODE_API_URL + "/INTL/onOff-Test-Mode",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
            },
            data: {
                "test_mode": event.target.checked ? "ON" : "OFF"
            },
        }).then((res) => {
            if (res && res.data && res.data.success) {
                setValue(res.data.msg)
                if (res.data.msg === "Test mode Deactivated") {
                    setChecked(false)
                } else {
                    setChecked(true)
                }

            }
        }).
            catch(error => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            })
    }
    const GenerateCredentails = () => {
        axios({
            method: "POST",
            url: NODE_API_URL + "/INTL/mail-ForTest-ModeAPI",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
            }
        }).then((res) => {
            if (res && res.data) {
                setValue(res.data)
                setCredentialGen(true)
            }
        }).
            catch(error => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            })
    }
    const GenerateLiveCredentails = () => {
        axios({
            method: "POST",
            url: NODE_API_URL + "/INTL/generate-NewToken",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${Cookies.get("cust_auth_token")}`
            }
        }).then((res) => {
            if (res && res.data) {
                setValue(res.data)
            }
        });
    }
    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        // console.log(result,"addDays")
        return result.toISOString();
    }
    function dateFormate(date) {
        let formattedDate = "";
        if (date) {
            let dateObj = new Date(date);
            dateObj = new Date(dateObj.getTime() - (330 * 60 * 1000))
            const year = dateObj.getFullYear();
            const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
            const day = ('0' + dateObj.getDate()).slice(-2);
            const timeString = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
            formattedDate = `${year}-${month}-${day} ${timeString}`;
        }
        return formattedDate;
    }
    const getActive = (date) => {
        let newdate = new Date().getTime()
        let userdate = new Date(date).getTime()
        let status = `<span class="label label-success label-pill label-inline px-5">Active</span>`
        if (userdate <= newdate) {
            status = `<span class="label label-danger label-pill label-inline px-5">InActive</span>`
        }
        return status
    }
    return (
        <>
            <SwalWarn show={swalWarnOpen} message={`Are you sure about changing the currency to ${popupcurrency} for the diamond feed?`} onHide={() => setSwalWarnOpen(false)} onClose={() => setSwalWarnOpen(false)} responseOnOk={() => UpdateCurrency(popupcurrency)} />
            <TaxPopUp show={edittax} onHide={() => CancelTax()} onClose={() => CancelTax(false)} responseOnOk={() => SaveTax()} setTaxName={setTaxName} setTaxValue={setTaxValue} taxname={taxname} taxvalue={taxvalue} />
            <React.Fragment>
                  <React.Fragment>
                  <div className="row pb-10">
                      <div className="col-12 mb-4 setting-title d-flex justify-content-between pb-5">
                            API Tax & Currency Setting
                      </div>
                      <div className="col-md-9 pl-md-10">
                        <div className="row align-items-center">
                            <div className="col-md-4">
                                <InputLabel className="font-size-h6 font-weight-bold">
                                    Display Price
                                </InputLabel>
                            </div>
                            <div className="col-md-6">
                                <SelectFieldCurrency
                                    name={"currency"}
                                    label={"Select Currency"}
                                    style={{minWidth: 300}}
                                    data={muti_currency_data}
                                    value={currencyvalue}
                                    onChange={(e) => currencyvalue?OpenPopup(e.target.value):UpdateCurrency(e.target.value)}
                                    // disabled={props.customerapi.length > 0}
                                />
                            </div>
                        </div>
                    </div>                          

                   <div className="col-12"> <hr className="my-10"/></div>
                    <div className="col-md-9 pl-md-10">
                        <div className="row align-content-center">
                            <div className="col-md-4">
                                <InputLabel className="font-size-h6 font-weight-bold">
                                    Tax Value %
                                </InputLabel>
                            </div>
                            <div className="col-md-6 d-flex">
                            <TextField
                                variant="outlined"
                                type="text"
                                name={"Tax"}
                                label={"Tax(%)"}
                                style={{minWidth: 300}}
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                // onChange={(e) => setTaxValue(e.target.value)}
                                disabled={true}
                                value={taxvalue && taxname?`Inclusive ${taxname} - ${taxvalue}%`:"Exclusive Tax"}
                            />
                            
                            {!edittax ? 
                                <button
                                    className="btn btn-text-dark btn-hover-light-dark"
                                    type="button"
                                    onClick={() => setEditTax(true)}
                                >
                                <FaRegEdit className="font-size-h5" />
                            </button> : ""}
                            </div>
                        </div>
                    </div>
                  </div>
                  </React.Fragment>
                </React.Fragment>
        </>
    );
};
